import React from 'react';
import { Box, Flex } from '@chakra-ui/react';
import Sidebar from '../../components/global/sideBar';
import Header from '../../components/provider/header';
import { ChakraProvider } from '@chakra-ui/react';
import Settings from '../../components/global/settings';

const SettingsPage = () => {
  return (
    <ChakraProvider>
      <Flex overflowY="auto" width="100%" maxW="100%" mx="auto">
        {/* Sidebar */}
      

        {/* Main Content Area */}
        <Box flex="1" ml="250px" display="flex" flexDirection="column" height="100vh">
          {/* Header */}
         

          {/* Main Content Box */}
          <Box 
            flex="1" 
            p={6} 
            overflowY="auto" 
            css={{
              '&::-webkit-scrollbar': {
                width: '0px',
              },
              'scrollbarWidth': 'none',
              '-ms-overflow-style': 'none',
            }}
          >
            {/* Settings Section */}
            <Box
              width="100%"
              maxWidth="1200px"
              margin="0 auto"
              backgroundColor="white"
              borderRadius="lg"
              boxShadow="md"
              p={8}
            >
              <Settings />
            </Box>
          </Box>
        </Box>
      </Flex>
    </ChakraProvider>
  );
};


export default SettingsPage;


